import React, {
  useState,
  useContext,
  useEffect
} from 'react';

import *
as VettingHelpers
from 'src/Components/CreditVetting/creditVettingUtils';

import
OrderSummary
from 'src/Components/Common/OrderSummary/OrderSummary';

import
VettingSectionHOC
from 'src/Components/CreditVetting/VettingSectionHOC/VettingSectionHOC';

import
VettingPersonalDetails
from 'src/Components/CreditVetting/VettingPersonalDetails/VettingPersonalDetails';

import
VettingContactDetails
from 'src/Components/CreditVetting/VettingContactDetails/VettingContactDetails';

import
VettingWorkDetails
from 'src/Components/CreditVetting/VettingWorkDetails/VettingWorkDetails';

import
VettingHomeAddress
from 'src/Components/CreditVetting/VettingHomeAddress/VettingHomeAddress';

import
VettingBankDetails
from 'src/Components/CreditVetting/VettingBankDetails/VettingBankDetails';

import
VettingCreditCheck
from 'src/Components/CreditVetting/VettingCreditCheck/VettingCreditCheck';

import
VettingPostalAddress
from 'src/Components/CreditVetting/VettingPostalAddress/VettingPostalAddress';

import
VettingBack
from 'src/Components/Common/VettingBack/VettingBack';

import {
  Heading,
  Paragraph
} from 'src/StyledComponents';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  addBeforeloadEvent,
  removeBeforeloadEvent
} from 'src/Utility/utility';

import {
  getDropDownValuesService,
  getDropDownValuesFromJsonService
} from 'src/Services/Services';

import {
  tagOnCreditVettingPageLoad,
  tagOnSectionDetailsFillingSave,
  tagOnSectionDetailsEditDetails,
  tagOnSectionDetailsFillingStart
} from 'src/Tagging/NewCustomerTagging';

import {
  provinces
} from 'src/Common/constants';

import './CreditVetting.css';

const CreditVetting = () => {

  const context = useContext(SalesContext);
  const vettingCreditDetails = context.vettingCreditDetails;
  const isUnemployed = context.isUnemployed;
  const [ enableContinue, setEnabledContinue ] = useState(false);
  const [ checkData, setCheckData ] = useState(false);
  const isHideVetAddress = context.userExistingProperties['hideVetAddress'];

  useEffect(() => {

    tagOnCreditVettingPageLoad();
    sections['personalDetails'].showBody && tagOnSectionDetailsFillingStart('Personal details');

    context.setProvinceList(provinces);

  }, []);

  useEffect(() => {

    addBeforeloadEvent();

    return () => removeBeforeloadEvent();
  }, []);

  const numberOfSections = isHideVetAddress ? '5' : '7';
  const initState = VettingHelpers.getCreditVettingInitialState(vettingCreditDetails, numberOfSections, isHideVetAddress);
  const [ sections, updateSections ] = useState(initState);

  const toggleSection = (key) => {

    const changedComponent = { ...sections[key] };
    changedComponent.showBody = !changedComponent.showBody;
    const newSection = { ...sections, [key]: changedComponent };
    updateSections(newSection);
  };

  const toggleNextButton = (key, value) => {

    const changedComponent = { ...sections[key] };
    changedComponent.enableNext = value;
    const newSection = { ...sections, [key]: changedComponent };
    updateSections(newSection);
    shouldEnableContinue();
  };

  const hideNextSections = (value) => {

    context.setIsUnemployed(value);
  };

  const onNextClick = (key, data) => {

    const changedComponent1 = { ...sections[key] };

    if (key !== 'creditCheck') {

      tagOnSectionDetailsFillingSave(changedComponent1.title);
    }

    changedComponent1.isDataAvailable = !!data;
    changedComponent1.isEditModeOn = false;

    const changedComponent2 = {
      ...sections[changedComponent1.showNext],
      showBody: true
    };

    if (key !== 'creditCheck') {

      tagOnSectionDetailsFillingStart(changedComponent2.title);
    }

    let newSection = null;

    if (changedComponent1.showNext) {

      let element = document.getElementById(key);
      let nextElement = document.getElementById(changedComponent1.showNext);

      if (key !== 'workDetails' && !isUnemployed) {
        window.scrollBy({
          top: nextElement.getBoundingClientRect().top - element.getBoundingClientRect().height / 2,
          behavior: 'smooth'
        });
      }

      newSection = { ...sections, [key]: changedComponent1, [changedComponent1.showNext]: changedComponent2 };
    } else {
      newSection = { ...sections, [key]: changedComponent1 };
    }

    updateSections(newSection);
    setCheckData(!checkData);
  };

  useEffect(() => {

    shouldEnableContinue();
  }, [ checkData ]);

  useEffect(() => {

    context.setShowSpinner(true);
    getDropDownValuesService()
      .then(res => {
        context.setDropDownValues(res.result);
        context.setShowSpinner(false);
      })
      .catch(_error => {
        getDropDownValuesFromJsonService()
          .then(res => {
            context.setDropDownValues(res.result);
            context.setShowSpinner(false);
          })
          .catch(_error => {

            context.setShowSpinner(false);
          });
        context.setShowSpinner(false);
      });
  }, []);

  const shouldEnableContinue = () => {

    let tempFlag = false;
    if (isUnemployed) {

      if (sections['personalDetails'].isDataAvailable &&
        sections['contactDetails'].isDataAvailable &&
        sections['workDetails'].isDataAvailable) {
        tempFlag = true;
      }
    } else {

      for (let key in sections) {

        if (sections[key].isDataAvailable) {

          tempFlag = true;
          continue;
        } else {

          if (key === 'homeAddress' || key === 'postalAddress' && isHideVetAddress) {
            continue;
          }
          tempFlag = false;
          break;
        }
      }
    }
    for (let key in sections) {

      if (!sections[key].isEditModeOn) {

        continue;
      } else {

        setEnabledContinue(false);

        return;
      }
    }

    setEnabledContinue(tempFlag);
  };

  const onEditClick = (key) => {

    shouldEnableContinue();
    tagOnSectionDetailsEditDetails();
    const changedComponent = { ...sections[key] };
    changedComponent.isEditModeOn = true;
    const newSection = { ...sections, [key]: changedComponent };
    updateSections(newSection);
  };

  return (
    <div className="credit-vettting-wrapper">

      <VettingBack
        backUrl="/cloud/fibre/sales/deliveryAddress" />

      <div className="credit-vetting-page-wrapper">

        <div className="credit-vetting-setion">

          <Heading
            style={{ padding: '8px' }}
            className="credit-vetting-setion-heading">

            Credit vetting
          </Heading>

          <Paragraph
            style={{ padding: '8px' }}
            automationidattr={'Credit vetting Desc'}>

            In order to process your contract application, we’ll need the following information to submit a credit check
          </Paragraph>

          {/* Personal Details */}
          <div id="personalDetails"
            className="credit-vetting-section-width">

            <VettingSectionHOC
              {...sections.personalDetails}
              toggleSection={(key) => toggleSection(key)}
              onEditClick={(key) => onEditClick(key)}>

              <VettingPersonalDetails
                toggleNext={(value) => toggleNextButton('personalDetails', value)}
                showBody={sections.personalDetails.showBody}
                enableNext={sections.personalDetails.enableNext}
                onNextClick={(data) => onNextClick('personalDetails', data)}
                isEditModeOn={sections.personalDetails.isEditModeOn} />
            </VettingSectionHOC>
          </div>

          {/* Contact Details */}
          <div id="contactDetails"
            className="credit-vetting-section-width">

            <VettingSectionHOC
              {...sections.contactDetails}
              toggleSection={(key) => toggleSection(key)}
              onEditClick={(key) => onEditClick(key)}>

              <VettingContactDetails
                toggleNext={(value) => toggleNextButton('contactDetails', value)}
                showBody={sections.contactDetails.showBody}
                enableNext={sections.contactDetails.enableNext}
                onNextClick={(data) => onNextClick('contactDetails', data)}
                name={ context?.vettingCreditDetails?.personalDetails?.firstName?.value}
                isEditModeOn={sections.contactDetails.isEditModeOn} />
            </VettingSectionHOC>
          </div>

          {/* Work Details */}
          <div id="workDetails"
            className="credit-vetting-section-width">

            <VettingSectionHOC
              {...sections.workDetails}
              toggleSection={(key) => toggleSection(key)}
              onEditClick={(key) => onEditClick(key)}>

              <VettingWorkDetails
                toggleNext={(value) => toggleNextButton('workDetails', value)}
                showBody={sections.workDetails.showBody}
                enableNext={sections.workDetails.enableNext}
                onNextClick={(data) => onNextClick('workDetails', data)}
                isEditModeOn={sections.workDetails.isEditModeOn}
                hideNextSection={(value) => hideNextSections(value)} />
            </VettingSectionHOC>
          </div>

          {!isUnemployed

            ? <React.Fragment>

              {/* Home Address */}
              { !isHideVetAddress &&

                <div id="homeAddress" className="credit-vetting-section-width">
                  <VettingSectionHOC
                    {...sections.homeAddress}
                    toggleSection={(key) => toggleSection(key)}
                    onEditClick={(key) => onEditClick(key)}>

                    <VettingHomeAddress
                      toggleNext={(value) => toggleNextButton('homeAddress', value)}
                      showBody={sections.homeAddress.showBody}
                      enableNext={sections.homeAddress.enableNext}
                      onNextClick={(data) => onNextClick('homeAddress', data)}
                      isEditModeOn={sections.homeAddress.isEditModeOn} />
                  </VettingSectionHOC>
                </div>
              }

              {/* Postal Address */}
              { !isHideVetAddress &&
                <div id="postalAddress"
                  className="credit-vetting-section-width">

                  <VettingSectionHOC
                    {...sections.postalAddress}
                    toggleSection={(key) => toggleSection(key)}
                    onEditClick={(key) => onEditClick(key)}>

                    <VettingPostalAddress
                      toggleNext={(value) => toggleNextButton('postalAddress', value)}
                      showBody={sections.postalAddress.showBody}
                      enableNext={sections.postalAddress.enableNext}
                      onNextClick={(data) => onNextClick('postalAddress', data)}
                      isEditModeOn={sections.postalAddress.isEditModeOn}
                    />
                  </VettingSectionHOC>
                </div>
              }

              {/* Bank Details */}
              <div id="bankAccountDetails"
                className="credit-vetting-section-width">

                <VettingSectionHOC
                  {...sections.bankAccountDetails}
                  toggleSection={(key) => toggleSection(key)}
                  onEditClick={(key) => onEditClick(key)}>

                  <VettingBankDetails
                    toggleNext={(value) => toggleNextButton('bankAccountDetails', value)}
                    showBody={sections.bankAccountDetails.showBody}
                    enableNext={sections.bankAccountDetails.enableNext}
                    onNextClick={(data) => onNextClick('bankAccountDetails', data)}
                    isEditModeOn={sections.bankAccountDetails.isEditModeOn} />
                </VettingSectionHOC>
              </div>

              {/* Credit Check */}
              <div id="creditCheck"
                className="credit-vetting-section-width">

                <VettingSectionHOC
                  {...sections.creditCheck}
                  toggleSection={(key) => toggleSection(key)}
                  onEditClick={(key) => onEditClick(key)}>

                  <VettingCreditCheck
                    toggleNext={(value) => toggleNextButton('creditCheck', value)}
                    showBody={sections.creditCheck.showBody}
                    enableNext={sections.creditCheck.enableNext}
                    onNextClick={(data) => onNextClick('creditCheck', data)}
                    isEditModeOn={sections.creditCheck.isEditModeOn}/>
                </VettingSectionHOC>
              </div>

            </React.Fragment>

            : null
          }
        </div>

        <OrderSummary
          submitRoute={isUnemployed ? '/cloud/fibre/sales/review-order' : '/cloud/fibre/sales/upload-documents'}
          isEnabled={enableContinue}
          page="new customer credit vetting"/>
      </div>
    </div>
  );
};

export default CreditVetting;